import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  createGrnForVehicleTracking,
  getStorageLocations,
} from 'src/redux/Actions/VehicleTracking';

export default function useGoodsReceivedNoteLogic() {
  const dispatch = useDispatch();
  const { vehicleTrackingNumber } = useParams();

  const [formData, setFormData] = useState({});
  const [invalidFormSubmission, setInvalidFormSubmission] = useState(false);

  const authReducer = useSelector((state) => state.AuthReducer);
  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const organisationId = authReducer.userData.organisations?.id;
  const themeColor = authReducer.userData.tenant?.theme;
  const { vehicleTrackingLineItemList } = vehicleTrackingDataReducer;
  const storageLocationsGroupedByPlant =
    vehicleTrackingDataReducer?.storageLocationsGroupedByPlant;

  useEffect(() => {
    const plantIds = Array.from(
      new Set(
        (vehicleTrackingLineItemList || [])
          .map((item) => item?.plant?.id)
          .filter(Boolean),
      ),
    );
    if (plantIds.length > 0) {
      dispatch(getStorageLocations(organisationId, plantIds));
    }
  }, [vehicleTrackingLineItemList, dispatch, organisationId]);

  const getStorageLocationOptionsForPlant = (plantId) => {
    const plant = storageLocationsGroupedByPlant?.find(
      (item) => item.plant_id === plantId,
    );
    const storageLocations = plant ? plant.storage_locations : [];
    return storageLocations.map((location) => ({
      value: location.id,
      label: `${location.sap_code} - ${location.name}`,
    }));
  };

  const handleCheckboxClick = (itemObj, isChecked) => {
    setFormData((prev) => {
      const existing = prev[itemObj.id] || {
        purchase_order_line_item_id: itemObj.purchase_order_line_item_id,
        receiving_quantity: itemObj.receiving_quantity,
        plant_id: itemObj.plant.id,
        storage_location_id: null,
        batch_number: null,
      };
      return {
        ...prev,
        [itemObj.id]: {
          ...existing,
          active: isChecked,
        },
      };
    });
  };

  const handleOnChange = (e, id) => {
    const { name, value } = e.target;
    const item = vehicleTrackingLineItemList.find((i) => i.id === id);
    if (!item) return;

    setFormData((prev) => {
      const existing = prev[id] || {
        purchase_order_line_item_id: item.purchase_order_line_item_id,
        receiving_quantity: item.receiving_quantity,
        plant_id: item.plant.id,
      };

      return {
        ...prev,
        [id]: {
          ...existing,
          [name]: value,
          active: true,
        },
      };
    });
  };

  const handleSubmit = () => {
    const activeItems = [];
    let invalidSubmission = false;

    Object.values(formData).forEach((data) => {
      if (data.active) {
        if (!data.storage_location_id) {
          invalidSubmission = true;
        } else {
          activeItems.push({
            purchase_order_line_item_id: data.purchase_order_line_item_id,
            receiving_quantity: data.receiving_quantity,
            plant_id: data.plant_id,
            storage_location_id: data.storage_location_id,
            batch_number: data.batch_number,
          });
        }
      }
    });

    if (invalidSubmission || activeItems.length === 0) {
      setInvalidFormSubmission(true);
      return;
    }

    const payload = {
      tenant_organisation_id: organisationId,
      vehicle_tracking_number: vehicleTrackingNumber,
      items: activeItems,
    };

    dispatch(createGrnForVehicleTracking(payload)).then(() => {
      window.location.reload();
    });
  };

  return {
    formData,
    setFormData,
    invalidFormSubmission,
    setInvalidFormSubmission,
    handleCheckboxClick,
    handleOnChange,
    handleSubmit,
    getStorageLocationOptionsForPlant,
    vehicleTrackingLineItemList,
    themeColor,
  };
}
